let checkoutContent = null;
let runningCheck = false;

const addProductQuantity = 50;
const config_voucher = { characterData: false, attributes: true, childList: false, subtree: false };
const config2 = { characterData: false, attributes: false, childList: true, subtree: true };

// Überwachung wenn popupcart eingeblendet wird dann inputfeld ausblenden
const observerVoucher = new MutationObserver( function( mutations ){
  mutations.forEach(function(mutation) {
    if( mutation.type == 'attributes' ){          
      if ( !$('html').hasClass( 'no-scroll' ) ){             
        $('.voucherRow').removeClass('showInput');
        $('body').removeClass('showNotOkayMessage');
        $('body').removeClass('showNOkayMessage');
      }
    }
  });
});
observerVoucher.observe( document.querySelector('.PageOverlay'), config_voucher);


function checkChangeQuantity( items, elem ){
   
  
  
  check = true;  
  if ( items === null ) return check;
  
  if ( items.length > 0 ){
    // haben wir hinzugefügte items dann überprüfen wir ob die Änderungen an diesen durchgeführt wurde - wenn ja is es uns egal
  
    
    for ( const item of items ){
      
      let searchString = '.QuantitySelector__CurrentQuantity[id^="updates_'+item['id']+'"]';      
      if (elem.parents('.CartItem__Actions').find(searchString).length > 0 ){
        check = false;
      }
    }    
   

  }

 
  return check;
}

function setNotOkay( voucherCode){
  
  runningCheck = false;
  $('.voucherRow').removeClass('testVoucher');
  
  $('.voucherRow .voucherCode').html( voucherCode );
  localStorage.removeItem('penobloVoucherCode');
  $('body').removeClass('showOkayMessage');
  $('body').addClass('showNotOkayMessage');	
}

function setOkay( voucherCode ){
  
  runningCheck = false;
  $('.voucherRow').removeClass('testVoucher');
  
  localStorage.setItem('penobloVoucherCode', JSON.stringify({
    'voucherCode': voucherCode
  }));
  

   $('.voucherRow .voucherCode').html( voucherCode );
   $('body').addClass('showOkayMessage');
   $('body').removeClass('showNotOkayMessage');


  // das gilt nur für die cart page
  if ( $('body').hasClass('template-cart') ){    
  	$('.additional_checkout_buttons').prev().remove();
  }
  $('.additional_checkout_buttons').remove();
  
  
}

function checkVoucher( voucherCode ){
     
  if ( runningCheck ) return;
  runningCheck = true;
  
  $('.voucherRow').addClass('testVoucher');

  
  // testen ob der Gutscheincode einfach gültig ist
  if ( checkCheckout( voucherCode ) ){ 
      setOkay( voucherCode );
      location.href='/checkout?discount='+voucherCode;      
      return;
  }
  

  
  // wenn nicht gültig dann anfragen ob eventuell produkte hinzugefügt werden müssen
  $.getJSON( webserviceUrl+'/voucher?code='+voucherCode, function(retval){

    // keine Produkte gefunden für den Code
    if ( retval.data === undefined ){        
      setNotOkay( voucherCode );
      return;
    }

    // keine Produkte gefunden für den Code
    if ( retval.data.length === 0 ){    
      setNotOkay( voucherCode );
      return;
    }

    // wenn wir items gefunden haben dann versuchen hinzuzufügen
    let addProducts = [];          
    let items = [];
    let itemsAll = {};


    for( const id of retval.data ){      
      items.push({
        quantity: addProductQuantity,
        id: id
      });
    } 

    // hinzufügen wenn 1 oder mehrere noch nicht vorhanden
    if ( items.length > 0 ){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { 'items': items },
        async:false
      });

      
    }

    // jetzt checken ob der Code jetzt gültig ist
    okay = checkCheckout( voucherCode );

    // Ergebnisse überprüfen und alle hinzufügenden Produkte überprüfen welche menge 
    updateItems = {};


    for ( let index in items ){

      const id = items[index]['id'];
      checkoutContent.find('tr.product[data-variant-id='+id+']').each( function(){                                       

        // haben wir einen reduzierten artikel
        if ( $(this).find('span.reduction-code__text').length > 0 ){


          if ( $(this).find('span.reduction-code__text').text().toLowerCase().includes( voucherCode.toLowerCase() ) ){

            // items wieder auf die vorherige Anzahl zurücksetzen
            const nullSum = $(this).find('.product-thumbnail__quantity').text();
            updateItems[ id ] = parseInt(nullSum);

          }
        }

      });

    }

    // wenn gutscheincode nicht okay dann items auf 0 zurücksetzen
    if ( !okay ){      
      for ( let index in items ){
        const id = items[index]['id'];
        updateItems[ id ] = 0;
      }
    }

    // items auf die anzahl setzen die kostenlos ist	
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { 'updates': updateItems },
      async:false
    });

	
    if ( !okay ){
      setNotOkay( voucherCode );
      return; 
    } else {      
     
	  $('.voucherRow').removeClass('showInput');      
      setOkay( voucherCode );
      location.href='/checkout?discount='+voucherCode;
      return;       

    }

  });
}

function checkCheckout( voucherCode ){ 
  
  let isValid = false;  
  
  
  $.ajax({
    type: "GET",
    url: '/checkout?discount='+voucherCode,
    async: false,
    success: function(data, status, xhr) {
      
      checkoutContent = $(data);

      isValid = false;
      if ( checkoutContent.find('.tags-list .reduction-code__text').length > 0 ){
        if( checkoutContent.find('.tags-list .reduction-code__text').html().toLowerCase() == voucherCode.toLowerCase() ){
          isValid = true;
        }
      }
    }
  });
  
  return isValid;
}
  

$( document ).ready(function() {
  
  let counterVisible = 0;  
  
  // Gutscheinaktionen nur durchführen wenn wir auch das Gutscheinfeld haben
  if ( $('[name=voucherCodeAdd]').length > 0 ){    
    
    // DEV
    if ( localStorage.getItem('test') == 'test' ){
      $('body').append('<style>.hiddenClicks{ display: block; }<style>');
      
    }

    // DEV
    $('.AnnouncementBar__Content').on('click', function(){
      counterVisible++;
      if ( counterVisible > 3 ){
        $('body').append('<style>.hiddenClicks{ display: block; }<style>');
        localStorage.setItem('test','test');
      }
    });    
    
    
    // Gutscheincodefeld anzeigen
    $('body').on('click','.voucherRow label', function(){    
      $('.voucherRow').addClass('showInput');
    })
    
   
    // wenn der Gutscheincode hinzugefügt wurde
	$('body').on('click','[name=voucherCodeAdd]', function(e){
      
      
        e.preventDefault();      	
		checkVoucher( $('[name=voucherCode]').val(), true, true );
      
    });
    
  }
  
  
});
